import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DualListBox from "../../../../core/BaseComponents/CustomDualList/DualListBox";
import { Autocomplete, Box, TextField } from "@mui/material";
import { Tooltip } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaHotel } from "react-icons/fa";
import RailConfigPreview from "./RailConfigPreview";
import BasicModal from "../../../../core/BaseComponents/Modal";

const accordionProps = {
  sx: {
    pointerEvents: "none",
    flexGrow: 1,
  },
  expandIcon: (
    <ExpandMoreIcon
      sx={{
        pointerEvents: "auto",
      }}
    />
  ),
};

export default function ChannelForYou(props) {
  const { selectedUtilityFullObject, tabs, defaultValue, masterChannelsList, masterGenresList, onSubmitHandler, selectedPartnerFullObject, railName, roomTypes, editPublishUnPublish, onResetHandler, onResetChannelsForYou, setChannelForYouData, setSelectedChannelForYouFullObject, tabChangeHandler, selectedHotelServiceFullObject, selectedHotelChannelFullObject, setPayloadChannelsForYou, showUtility } = props

  const [steps, setSteps] = useState([]);
  const [count, setCount] = useState(1);

  const [expanded, setExpanded] = useState(false);
  const [preview, setPreview] = useState(false);
  const [previewChannelData, setPreviewChannelData] = useState([]);

  useEffect(() => {
    if (defaultValue?.length && masterChannelsList?.length) {
      // console.log(defaultValue);

      // Create a deep copy of defaultValue
      setCount(defaultValue?.length + 1)
      const updatedPayload = defaultValue?.map(channelData => ({ ...channelData }));
      const defaultSids = defaultValue?.map((channel) => channel?.channels?.map((item) => item?.channelId));
      const channelDefaultData = defaultValue?.map((channel) => channel?.channels?.map((item) => ({...item})));
      // Map over the defaultValue to add availableChannels
      const addedChannelsPayload = updatedPayload.map((channelData,index) => ({
        ...channelData,
        channels: masterChannelsList.filter(channel =>
          channelData?.genres?.includes(channel?.genre) && defaultSids[index]?.includes(channel?.sid)),
        availableChannels: masterChannelsList.filter(channel =>
          channelData?.genres?.includes(channel?.genre) && !defaultSids[index]?.includes(channel?.sid)
        ),
      }));
      const sequenceAddedData = addedChannelsPayload?.map((channelData,index)=>({...channelData, channels: channelData?.channels?.map((channel)=>({...channel, sequenceNo:channelDefaultData[index]?.find(def=>def?.channelId === channel?.sid)?.sequenceNo}))}))
      const sortedData = sequenceAddedData?.map((channelData)=>({...channelData,channels: channelData?.channels?.sort((a,b)=>a.sequenceNo-b.sequenceNo)}))
      // Update steps with the modified payload
      setSteps(sortedData);
      setPreviewChannelData(sortedData);
    }
    else{
      setSteps([])
    }
  }, [defaultValue, masterChannelsList]);

  const addCategoryId = (e) => {
    e.preventDefault();
    setExpanded(`panel${editPublishUnPublish ? count + 1 : count}`);
    setCount((prev) => prev + 1);
    setSteps([
      ...steps,
      {
        sequenceNo: editPublishUnPublish ? count + 1 : count,
        categoryName: "",
        genres: [],
        channels: [],
        availableChannels: masterChannelsList,
      },
    ]);
  };

  // Remove duplicates based on 'sid' using Map
  const removeDuplicatesBySid = (channels) => {
    const seen = new Map();
    return channels.filter(channel => {
      if (!seen.has(channel.sid)) {
        seen.set(channel.sid, true);
        return true;
      }
      return false;
    });
  };

  // Updated handler
  const onChangeHandler = (value, sequenceNo, name) => {
    setSteps((prevSteps) => {
      return prevSteps.map((item) => {
        if (item.sequenceNo === sequenceNo) {
          const updatedStep = { ...item };

          updatedStep[name] = value;
          if (name === "genres") {
            if (value?.length && Array.isArray(value)) {
              const filteredChannels = masterChannelsList?.filter((channel) => 
                value?.includes(channel?.genre) &&
                !updatedStep.channels?.some((existingChannel) => existingChannel?.id === channel?.id)
              );
              
              // Remove duplicates by sid
              updatedStep.availableChannels = removeDuplicatesBySid(filteredChannels);
              updatedStep.channels = updatedStep.channels?.filter((channel) =>
                value?.includes(channel?.genre)
              );
            } else {
              updatedStep.availableChannels = masterChannelsList;
              updatedStep.channels = []
            }
          }
          return updatedStep;
        }
        return item;
      });
    });
  };

  const onPreviewHandler = () => {
    setPreviewChannelData(steps);
    setSelectedChannelForYouFullObject(steps)
    const payload = JSON.parse(JSON.stringify(steps));

    const updatedPayload = payload?.map((data) => {
      const updatedChannelIds = data?.channels?.map(
        (innerData,index) => ({channelId:innerData?.sid, sequenceNo: index+1})
      );
      const { availableChannels, ...restData } = data;
      return {
        ...restData,
        channels: updatedChannelIds,
      };
    });
    setPayloadChannelsForYou({ channelCategories: updatedPayload })
    setChannelForYouData(updatedPayload)
    setPreview(true);
  }

  const onSaveHandler = () => {
    setSelectedChannelForYouFullObject(steps)
    const payload = JSON.parse(JSON.stringify(steps));

    const updatedPayload = payload?.map((data) => {
      const updatedChannelIds = data?.channels?.map(
        (innerData,index) => ({channelId:innerData?.sid, sequenceNo: index+1})
      );
      const { availableChannels, ...restData } = data;
      return {
        ...restData,
        channels: updatedChannelIds,
      };
    });
    // localStorage.setItem(
    //   "channelsForYou",
    //   JSON.stringify({ channelCategories: updatedPayload })
    // );
    setPayloadChannelsForYou({ channelCategories: updatedPayload })
    setChannelForYouData(updatedPayload)
    const nextTab = tabs?.find((data)=>data?.railName==="linearChannel")
    if(nextTab?.sequenceNo<5){
      tabChangeHandler(nextTab?.sequenceNo)
    }
    else{
      setPreview(true);
    }
    // onPreviewHandler()
    // onSubmitHandler()
    // onPreviewHandler()
  }

  function handleRemove(e, sequenceNo) {
    e.stopPropagation();

    const selectedStep = steps.filter((item) => item.sequenceNo !== sequenceNo);
    setSteps(selectedStep);
    setPreviewChannelData(selectedStep);
  }

  function handleOnDragEnd(result) {
    const { source, destination } = result;

    // If there's no valid destination or source and destination are the same, do nothing
    if (!destination || source.index === destination.index) return;

    // Clone the array to avoid directly mutating the state
    const updatedSteps = Array.from(steps);

    // Remove the item from the source index and store it
    const [reorderedItem] = updatedSteps.splice(source.index, 1);

    // Insert the item into the new destination index
    updatedSteps.splice(destination.index, 0, reorderedItem);

    // Ensure that the sequenceNo is updated based on the new order
    const updatedWithSequence = updatedSteps.map((step, index) => ({
      ...step,
      sequenceNo: index + 1, // Assigning sequenceNo starting from 1
    }));

    // Update the state with the new steps array
    setSteps(updatedWithSequence);
  }

  const handleExpanded = (panel) => (e, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // const initialRender = useRef(true)
  // useEffect(()=>{
  //   if(initialRender.current){
  //     initialRender.current = false
  //   }
  //   else{
  //     const payload = JSON.parse(JSON.stringify(steps));

  //   const updatedPayload = payload?.map((data) => {
  //     const updatedChannelIds = data?.channelIds?.map(
  //       (innerData) => innerData?.sid
  //     );
  //     const { availableChannels, ...restData } = data;
  //     return {
  //       ...restData,
  //       channelIds: updatedChannelIds,
  //     };
  //   });
  //   setChannelForYouData(updatedPayload)
  //   }
  // },[steps])

  function updateSubsteps(stepsArray, stepToMatch, newSubsteps) {
    return stepsArray.map((stepObject) => {
      if (stepObject.sequenceNo === stepToMatch) {
        return {
          ...stepObject,
          channels: newSubsteps,
        };
      }
      return stepObject;
    });
  }

  function handleItemsChange(updatedRightItems, sequenceNo) {
    setSteps((prev) => updateSubsteps(prev, sequenceNo, updatedRightItems));
  }

  return (
    <div className="channels-for-you">
      {/* <div className="m-auto"> */}
      <button
        className="createuser"
        onClick={addCategoryId}
      >
        <AddIcon /> Add New Category
      </button>

      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="steps">
          {(provided) => (
            <ul
              className="pl-0 list-unstyled"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {steps?.map((item, index) => (
                <Draggable
                  key={String(item.sequenceNo)}
                  draggableId={String(item.sequenceNo)}
                  index={index}
                >
                  {(provided) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Accordion
                        className="mt-0 mb-1 border"
                        key={item.sequenceNo}
                        expanded={expanded === `panel${item.sequenceNo}`}
                        onChange={handleExpanded(`panel${item.sequenceNo}`)}
                      >
                        <Box className="accordion-header">
                          <AccordionSummary
                            className="pr-0"
                            {...accordionProps}
                          >
                            <div className="accordion-header-title Roboto-Medium">
                              <div>Category Name: {item?.categoryName}</div>
                              <span>
                                <Tooltip
                                  title="Delete"
                                  className="cursor-pointer"
                                  arrow
                                >
                                  <DeleteIcon
                                    className="delete-icon-enable"
                                    onClick={(e) =>
                                      handleRemove(e, item.sequenceNo)
                                    }
                                  />
                                </Tooltip>
                              </span>
                            </div>
                          </AccordionSummary>
                        </Box>
                        <AccordionDetails className="mt-2 ml-3 mr-3">
                          <>
                            <div className="row">
                              <div className="form-group-hotel col-6">
                                <div className="floating-label">
                                  <FaHotel className="new-hotel-icons" />
                                  <input
                                    id="categoryName"
                                    maxLength={40}
                                    placeholder=""
                                    value={item?.categoryName}
                                    onChange={(e) => onChangeHandler(
                                      e.target.value,
                                      item.sequenceNo,
                                      "categoryName"
                                    )}
                                  // {...register("categoryName", {
                                  //   required: "Enter Rail Name",
                                  //   onChange: (e) => {
                                  //     onChangeHandler(
                                  //       e.target.value,
                                  //       item.sequenceNo,
                                  //       "categoryName"
                                  //     );
                                  //   },
                                  // })}
                                  />
                                  <label htmlFor="categoryName">
                                    Enter Category Name
                                  </label>
                                </div>
                                {/* {errors.categoryName && (
                                    <small className="required">
                                      {errors.categoryName.message}
                                    </small>
                                  )} */}
                              </div>

                              {item?.categoryName !== "" && (
                                <div className="col-6 form-group-hotel">
                                  <div className="floating-select-label">
                                    {/* <Controller
                                        name="genres"
                                        control={control}
                                        render={({ field }) => ( */}
                                    <Autocomplete
                                      // {...field}
                                      className={`multiselectlist ${item?.genres?.length > 0
                                        ? "Mui-focused"
                                        : ""
                                        }`}
                                      limitTags={2}
                                      disablePortal
                                      multiple
                                      options={masterGenresList}
                                      getOptionLabel={(option) =>
                                        option.toString()
                                      }
                                      value={item?.genres?.length ? item?.genres : []}
                                      onChange={(e, newValue) => {
                                        onChangeHandler(
                                          newValue,
                                          item.sequenceNo,
                                          "genres"
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder=""
                                          variant="outlined"
                                          label="Select Genre"
                                          InputLabelProps={{
                                            shrink: false,
                                          }}
                                        />
                                      )}
                                    />
                                    {/* )} */}
                                    {/* /> */}
                                  </div>
                                </div>
                              )}
                              {item?.categoryName !== "" && item?.genres?.length>0 && (
                                <div className="mt-2">
                                  <DualListBox
                                    listTitle="List Of Channels"
                                    selectedListTitle="Selected Channels"
                                    items={item?.availableChannels}
                                    initialData={item?.channels}
                                    onChange={(selected) =>
                                      handleItemsChange(
                                        selected,
                                        item?.sequenceNo
                                      )
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        </AccordionDetails>
                      </Accordion>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
      {/* </div> */}
      <div className="text-end">
        {editPublishUnPublish && <button
          onClick={onResetChannelsForYou}
          type="button"
          className="create-btn ms-2"
        >
          Reset
        </button>}
        <button
          onClick={onPreviewHandler}
          type="button"
          className="create-btn ms-2"
        >
          preview
        </button>
        <button
          onClick={onSaveHandler}
          type="button"
          className="create-btn ms-2"
        >
          {editPublishUnPublish ? "Update" : "Save"}
        </button>

      </div>
      {preview && <BasicModal
        popupOpen={preview}
        bodyMessage={<RailConfigPreview
          setPreview={setPreview}
          // onSubmitHandler={onSubmitHandler}
          // editPublishUnPublish={editPublishUnPublish}
          previewListRowData={{ roomTypes, railName }}
          onCreateRailConfigPreview={true}
          tabs={tabs}
          showUtility={showUtility}
          onResetHandler={onResetHandler}
          previewUtilityData={selectedUtilityFullObject}
          previewPartnerData={selectedPartnerFullObject}
          previewChannelData={previewChannelData}
          previewHotelServiceData={selectedHotelServiceFullObject}
          previewHotelChannelData={selectedHotelChannelFullObject}
        />}
        popupSize={'col-11 rails-preview'}
        footer={{
          ...(editPublishUnPublish && {
            thirdButton: {
              buttonName: "Reset Rail",
              action: () => onResetHandler(),
            },
          }),
          // primaryButton: {
          //   buttonName: `${editPublishUnPublish ? "Update" : "Create"} Rail`,
          //   action: () => onSubmitHandler(false),
          // },
          secondaryButton: {
            buttonName: "Publish Rail",
            action: () => onSubmitHandler(true)
          }
        }
        }
        popBtnAlignment='justify-content-end'
      />
      }
    </div>
  );
}
